import api from './api'
import { User } from '@/stores/authStore'

/**
 * Get current authenticated user
 */
export async function getCurrentUser(): Promise<User> {
  const response = await api.get('/auth/me')
  // The /auth/me endpoint returns { user: {...}, profile: {...} }
  // Extract just the user object
  const userData = response.data.user || response.data.data || response.data
  return userData
}
